"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @preserve
 * Copyright 2015-2018 Igor Bezkrovnyi
 * All rights reserved. (MIT Licensed)
 *
 * iq.ts - Image Quantization Library
 */
var distanceCalculator_1 = require("./distanceCalculator");
exports.AbstractDistanceCalculator = distanceCalculator_1.AbstractDistanceCalculator;
var cie94_1 = require("./cie94");
exports.CIE94Textiles = cie94_1.CIE94Textiles;
exports.CIE94GraphicArts = cie94_1.CIE94GraphicArts;
var ciede2000_1 = require("./ciede2000");
exports.CIEDE2000 = ciede2000_1.CIEDE2000;
var cmetric_1 = require("./cmetric");
exports.CMetric = cmetric_1.CMetric;
var euclidean_1 = require("./euclidean");
exports.AbstractEuclidean = euclidean_1.AbstractEuclidean;
exports.Euclidean = euclidean_1.Euclidean;
exports.EuclideanBT709NoAlpha = euclidean_1.EuclideanBT709NoAlpha;
exports.EuclideanBT709 = euclidean_1.EuclideanBT709;
var manhattan_1 = require("./manhattan");
exports.AbstractManhattan = manhattan_1.AbstractManhattan;
exports.Manhattan = manhattan_1.Manhattan;
exports.ManhattanBT709 = manhattan_1.ManhattanBT709;
exports.ManhattanNommyde = manhattan_1.ManhattanNommyde;
var pngQuant_1 = require("./pngQuant");
exports.PNGQuant = pngQuant_1.PNGQuant;
//# sourceMappingURL=index.js.map